
class ClearCommand {
    constructor(type, env) {
        this.type = type;
        this.env = env
    }
    resetJianshan() {
        const jsContainer = this.env.objects.jsContainer;
        if (!jsContainer) {
            return;
        }
        jsContainer.visible = true;
        jsContainer.position.set(0, 0, 0);
        jsContainer.scale.set(1, 1, 1);
        if (this.env.listener['jianshan-reset']) {
            this.env.listener['jianshan-reset']({
                visible: true,
                size: 1,
                position: { x: 0, y: 0, z: 0 }
            });
        }
    }
    do() {
        const isClearAll = !this.type || this.type === 'all';
        if (this.type === 'flower' || isClearAll) {
            for (let i = this.env.objects.flowers.length - 1; i > -1; i--) {
                this.env.objects.flowers[i].remove()
            }
        }
        if (this.type === 'container' || isClearAll) {
            if (isClearAll && this.env.setContainerLight) {
                this.env.setContainerLight(false);
            }
            const containers = this.env.getContainerList
                ? this.env.getContainerList()
                : (this.env.objects.container ? [this.env.objects.container] : []);
            for (let i = containers.length - 1; i > -1; i--) {
                containers[i].remove();
            }
            this.env.objects.container = null;
            this.env.objects.containers = [];
            this.env.selectedContainerId = '';
            if (this.env.listener['container-add']) {
                this.env.listener['container-add'](null);
            }
            if (this.env.listener['studio-containers-change']) {
                this.env.listener['studio-containers-change']([]);
            }
        }
        if (isClearAll) {
            this.resetJianshan();
        }
    }

}

export default ClearCommand;
